<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">alternate_email</mat-icon>
        <span>
            E-Mail Vorschau
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <div class="inner">

            <app-msg-preview [blob]="blob" [fileName]="fileName"></app-msg-preview>

        </div>

    </div>

</div>
